import { UserName } from 'infrastructure/security/authentication/authenticatedUserService';

export const OWNER_SOURCE = 'ownerAlias';

export const getFullName = (nameObject: UserName) => `${nameObject.firstName} ${nameObject.lastName}`;
